import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { Base } from "../../framework/base";

let _msalInstance: PublicClientApplication = null;

const createMsalInstance = async (clientId: string, redirectUri: string) => {
    if (_msalInstance) return _msalInstance;
    const msalConfig = {
        auth: {
            clientId,
            redirectUri,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: any, message: any, containsPii: any) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                    case LogLevel.Error:
                        console.error("[App] MSAL Error:", message);
                        return;
                    case LogLevel.Info:
                        console.info("[App] MSAL Info:", message);
                        return;
                    case LogLevel.Verbose:
                        console.debug("[App] MSAL Verbose:", message);
                        return;
                    case LogLevel.Warning:
                        console.warn("[App] MSAL Warning:", message);
                    }
                }
            }
        }
    };
    _msalInstance = new PublicClientApplication(msalConfig);
    await _msalInstance.initialize();
    return _msalInstance;
};

// #region Account Linking
export const msalPopupLoginForAccountLinking = async (clientId: string, redirectUri: string, prompt: "select_account" | "login" | "consent" | "create") => {
    const popupLoginRequest = {
        scopes: ["User.Read"],
        prompt,
    };
    try {
        const msalInstance = await createMsalInstance(clientId, redirectUri);
        const popupResult = await msalInstance.loginPopup(popupLoginRequest);
        if (!popupResult) return null;
        return popupResult;
    } catch (error) {
        console.error("[App] MSAL Popup Login Error:", error);
    }
};
// #endregion Account Linking

// #region Login with MS Account
// const loginWithHomeAccountId = async (token: string, homeAccountId: string) => {
//     const queryString = window.location.search;
//     const urlParams = new URLSearchParams(queryString);
//     const returnUrl = urlParams.get("ReturnUrl");
//     $.ajax({
//         type: "POST",
//         dataType: "json",
//         contentType: "application/json; charset=utf-8",
//         url: $("#LoginWithEntraUrl").val(),
//         cache: false,
//         data: JSON.stringify({
//             Token: token,
//             ReturnUrl: returnUrl ?? null,
//             HomeAccountId: homeAccountId
//         }),
//         success: function (data) {
//             console.log("[App] loginWithHomeAccountId", data);
//             if (!data.isSuccess) {
//                 showErrorMessage(data.message);
//                 return;
//             }
//             if (data.returnUrl && data.returnUrl !== "null") {
//                 window.location.href = data.returnUrl;
//             }
//         }
//     });
// };

const msalPopupLogin = async (clientId: string, apiScope: string, redirectUri: string, prompt: "select_account" | "login" | "consent" | "create", loginWithHomeAccountId: (token: string, homeAccountId: string) => void) => { //"select_account", "login", "consent", "create"
    const popupLoginRequest = {
        scopes: [apiScope],
        prompt,
    };
    try {
        const msalInstance = await createMsalInstance(clientId, redirectUri);
        const popupResult = await msalInstance.loginPopup(popupLoginRequest);
        console.log("[App] loginPopup result", popupResult);
        if (!popupResult) return;
        // Login to app with homeAccountId
        loginWithHomeAccountId(popupResult.accessToken, popupResult.account.homeAccountId);
    } catch (error) {
        console.error("[App] MSAL Popup Login Error:", error);
        if (Base.isString(error) && error.includes("AADSTS650051")) { // Known consent error for first sign-in in muli-tenant apps
            await msalPopupLogin(clientId, apiScope, redirectUri, "select_account", loginWithHomeAccountId);
        }
    }
};

export const checkSsoLogin = async (clientId: string, apiScope: string, redirectUri: string, loginWithHomeAccountId: (token: string, homeAccountId: string) => void) => {
    const msalInstance = await createMsalInstance(clientId, redirectUri);
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        console.log("[App] MSAL Accounts:", accounts);
        await msalPopupLogin(clientId, apiScope, redirectUri, "select_account", loginWithHomeAccountId);
    } else {
        console.log("[App] MSAL No user account found in cache");
        await msalPopupLogin(clientId, apiScope, redirectUri, "login", loginWithHomeAccountId);
    }
};
// #endregion Login with MS Account
